export default __webpack_public_path__ + "static/media/game-pagetype-ended_game.87489712.svg";